module.exports = __webpack_public_path__ + "img/Eyes.7ff7cffd.jpg";